<template>
  <v-sheet v-if="edit">
    <v-text-field v-model="newTitle" autofocus />
    <v-sheet class="d-flex justify-end"
      ><v-btn @click="edit = false">Cancel</v-btn
      ><v-btn
        :disabled="!newTitle || newTitle === issue.title"
        @click="
          emit('change', newTitle);
          edit = false;
        "
        >Save</v-btn
      >
    </v-sheet>
  </v-sheet>
  <h2 v-else @click="emit('show-buttons')">
    <span><IssueTitle :issue /></span
    ><v-sheet v-if="showButtons" class="float-end"
      ><v-btn
        icon="mdi-close"
        variant="plain"
        @click.stop="emit('hide-buttons')"
      /><v-btn
        v-tooltip:bottom="'Edit the issue title'"
        variant="plain"
        @click="
          edit = true;
          newTitle = issue.title || '';
        "
        >Edit</v-btn
      >
      <v-btn
        v-tooltip:bottom="'Go to issue at forgejo'"
        :href="issue.html_url"
        icon="mdi-link"
        variant="plain"
      />
    </v-sheet>
  </h2>
</template>
<script setup lang="ts">
import type { Issue } from "../gen/forgejo-vue";
import { ref } from "vue";
const props = defineProps<{
  issue: Issue;
  showButtons: boolean;
}>();
const emit = defineEmits<{
  (e: "change", title: string): void;
  (e: "show-buttons" | "hide-buttons"): void;
}>();

const edit = ref(false);
const newTitle = ref(props.issue.title ?? "");
</script>
